<template>
  <button
    class="signup-back-button bg-gray-100 absolute rounded-full h-9 w-9 flex justify-center items-center pl-1 pt-1 cursor-pointer focus:outline-none"
    :aria-label="$t('Accessibilty.AriaLabels.GoBack')"
    @click="$emit('back-button-click')"
  >
    <OSvg svg="arrow-left" class="fill-gray-400 w-4 ml-1" />
  </button>
</template>

<script>
const OSvg = () => import('@/components/OSvg')

export default {
  name: 'SignUpBackButton',
  components: {
    OSvg
  }
}
</script>

<style lang="postcss" scoped>
.signup-back-button {
  left: 2rem;
  top: -0.4rem;
}

@screen lg {
  .signup-back-button {
    top: 4rem;
  }
}

@screen md {
  .signup-back-button {
    @apply z-70
  }
}
</style>
